<template>
  <v-container grid-list-md>
    <v-slide-y-transition mode="out-in">
      <v-card grid-list-md>
        <v-toolbar flat color="grey lighten-3">
          <v-toolbar-title>Users</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field flat label="Search..." append-icon="search" v-model="search"></v-text-field>
          <v-tooltip v-if="loggedInUser.securityMask.charAt(parseInt(this.access['UserAdd'])-1) == '1'" bottom>
            <v-btn slot="activator" icon @click="addUser">
              <v-icon>add</v-icon>
            </v-btn>
            <span>New User</span>
          </v-tooltip>
        </v-toolbar>
        <v-expansion-panel v-model="panel" expand lazy>
          <v-expansion-panel-content v-for="user in filteredItems" :key="user.UserID">
            <div slot="header">
              <h4 class="name">{{ user.LastName }}, {{ user.FirstName }}</h4>
              <div class="quick-view" v-if="user.actions">
                <v-tooltip bottom v-for="action in user.actions" :key="action.ActionID">
                  <div
                    slot="activator"
                    class="circle"
                    v-bind:style="{ backgroundColor: action.DropDownsColor }"
                  ></div>
                  <span>{{ action.ActionName }}</span>
                </v-tooltip>
              </div>
            </div>
            <v-card>
              <v-card-text class="grey lighten-3">
                <v-layout row wrap="">
                  <v-flex v-for="action in user.actions" :key="action.ActionID" xs6 md4 d-flex>
                    <v-card
                      class="action-card"
                      light
                      v-bind:style="{ borderLeftColor: action.DropDownsColor }"
                      @click.native="viewAction(action.ActionID)"
                    >
                      <v-card-text>
                        <h4>{{ action.ActionName }}</h4>
                        <div>{{ action.DaysOfWeek }}</div>
                        <div>{{ action.TimeOfDay }}</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-card-text
                  v-if="!user.actions"
                  class="text-xs-center"
                >Currently no actions available for user.</v-card-text>
              </v-card-text>
              <v-card-actions class="grey lighten-3">
                <v-spacer></v-spacer>
                <v-btn v-if="loggedInUser.securityMask.charAt(parseInt(access['ActionAdd'])-1) == '1'" flat color="blue" @click="addActionForUser(user)">Add Action</v-btn>
                <v-btn v-if="loggedInUser.securityMask.charAt(parseInt(access['UserEdit'])-1) == '1'" flat color="blue" @click="editUser(user)">Edit User</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import RestService from '../services/RestService';
import * as Sentry from '@sentry/browser';

const service = new RestService();

export default {
  name: 'Users',
  props: {
    msg: String
  },
  data() {
    return {
      loggedInUser: {},
      access: {},
      users: [],
      panel: [],
      search: ''
    };
  },
  computed: {
          filteredItems() {
            return this.users.filter(user => {
              return (
                user.LastName.toLowerCase().includes(this.search.toLowerCase()) ||
                user.FirstName.toLowerCase().includes(this.search.toLowerCase()) ||
                user.PhoneNumber.toLowerCase().includes(this.search.toLowerCase()) ||
                user.Email.toLowerCase().includes(this.search.toLowerCase())
              )
            })
          }  
  },
  methods: {
    viewUser(user) {
      this.$router.push('/actions/' + user.UserID);
    },
    getAvatarUrl(user) {
      return 'https://api.adorable.io/avatars/282/' + user.UserID;
    },
    logout() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    viewAction(actionId) {
      this.$router.push(
        '/user/' + this.loggedInUser.UserID + '/action/' + actionId
      );
    },
    addAction() {
      this.$router.push('/user/' + this.loggedInUser.UserID + '/action');
    },
    addActionForUser(user) {
      this.$router.push('/user/' + user.UserID + '/action');
    },
    addUser() {
      this.$router.push('/user');
    },
    editUser(user) {
      this.$router.push('/user/' + user.UserID);
    }
  },
  created() {
    this.loggedInUser = this.$store.getters['auth/user'];
    this.access = this.$store.getters['auth/access'];
    console.log('User ', this.loggedInUser);
    service
      .getUsersActionsByParent(this.loggedInUser.UserID)
      .then(response => {
        this.panel = [];
        if (response) {
          this.users = response.data.body;
          for (var i = 0; i < this.users.length; i++) {
            this.panel[i] = false;
          }
        }
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });
  }
};
</script>

<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.card {
  background-color: #fff;
}
.status-failed {
  background-color: $color-status-failed;
  border-color: $color-status-failed;
}
.status-inactive {
  background-color: $color-status-inactive;
  border-color: $color-status-inactive;
}
.status-good {
  background-color: $color-status-good;
  border-color: $color-status-good;
}
.user-info {
  cursor: pointer;
}
.name {
  text-transform: uppercase;
}
.user-block {
  margin-bottom: 25px;
}
.quick-view {
  margin: 5px 0 2px 0;
  height: 18px;
}
.circle {
  width: 18px;
  height: 18px;
  border-radius: 9px;
  background: #424242;
  display: inline-block;
  margin-right: 5px;
}
.action-card {
  border-left-width: 8px;
  border-left-style: solid;
  cursor: pointer;
}
</style>
